var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordInputIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.98938 15.2372C6.98938 15.2372 12.9303 13.4832 12.9303 8.64787C12.9303 3.8118 13.1456 3.43427 12.6693 2.96916C12.1923 2.50405 7.76839 1 6.98938 1C6.21037 1 1.78642 2.50405 1.31018 2.96916C0.833175 3.43427 1.04845 3.8118 1.04845 8.64787C1.04845 13.4832 6.98938 15.2372 6.98938 15.2372Z",
    stroke: "#B3B3CC",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97656 7.88887L6.44166 9.31969L9.46014 6.375",
    stroke: "#B3B3CC",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordInputIcon);
export default __webpack_public_path__ + "static/media/password-input-icon.d30ebbd0cc95ef79c1d759006ce03934.svg";
export { ForwardRef as ReactComponent };